import React from 'react';
import styled, { useTheme } from 'styled-components';
import { PHONE_MEDIA_QUERY } from '../../../../common/responsive';
import WidthContainer from '../../../WidthContainer';
import { Heading1Text, ParagraphLargeText, TitleLarge } from '../../../Texts';
import Line from '../../../Line';

const InnerContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Container = styled.div`
  min-height: 800px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media ${PHONE_MEDIA_QUERY} {
    flex-direction: column;
    padding: 40px 0px;
  }
`;

const ColorizedSpan = styled.span`
  background-image: linear-gradient(
    90deg,
    ${({ theme }) => theme.text.title} 0%,
    ${({ theme }) => theme.special.purple} 30%,
    ${({ theme }) => theme.primary.primary} 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

export const StepsImageContainer = styled.div`
  width: 100%;
  max-width: 448px;

  img {
    width: 100%;
    height: auto;
  }

  @media ${PHONE_MEDIA_QUERY} {
    max-width: 100%;
    padding: 0 20px;
  }
`;

const Item = styled.div`
  padding: 20px;
  width: 100%;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.primary.background};
`;

const StyledTitleLarge = styled(TitleLarge)`
  font-weight: 600;
`;

const NextSteps = () => {
  const theme = useTheme();

  return (
    <div>
      <WidthContainer>
        <Container>
          <InnerContainer>
            <Heading1Text style={{ color: theme.text.title, width: '100%' }}>
              Next <ColorizedSpan>Steps</ColorizedSpan>
            </Heading1Text>
          </InnerContainer>
          <InnerContainer
            style={{
              gap: 40,
            }}
          >
            <Item>
              <a
                href='https://calendly.com/kevin-deks/deks-platform-intro'
                target='_blank'
              >
                <StyledTitleLarge>Book your 15-min call</StyledTitleLarge>
              </a>
            </Item>
            <Item>
              <StyledTitleLarge>
                Launch your card within the week!
              </StyledTitleLarge>
            </Item>
            <Item>
              <StyledTitleLarge>Questions? info@deks.xyz</StyledTitleLarge>
            </Item>
          </InnerContainer>
        </Container>
      </WidthContainer>
    </div>
  );
};

export default NextSteps;
